<template>
  <div class="pay"  v-if="!ispayed">
    <h2>扫码支付</h2>
    <div class="qrcode-box"  >
    <div id="qrcode"></div>
    </div>
    <p>请使用支付宝扫码付款</p>
  </div>
  <div class="pay" v-else-if="ispayed">
    已支付完成  会员到期时间是: {{this.expire_date}}
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import axios from '../../utils/request'
export default {

  data () {
    return {
      ispayed: false,
      expire_date: '',
      month: this.$route.query.month,
      price: this.$route.query.price,
      orderNo: ''
    }
  },

  mounted () {
    this.createOrder()
  },

  beforeDestroy () {
    this.stopPolling()
  },

  methods: {
    createOrder () {
      const orderno = parseInt(new Date().getTime() / 1000) + ''
      this.order_no = orderno
      console.log(this.orderNo)
      axios.post('/order/create', {
        buy_months: this.month,
        amount: this.price,
        order_no: this.order_no
      }).then(res => {
        let payUrl = res.data
        new QRCode('qrcode', {
          text: payUrl,
          width: 200,
          height: 200
        })
        // 等二维码渲染到 DOM 后再开始轮询，避免取到上次购买成功的记录
        this.$nextTick(() => {
          const qrcodeEl = document.getElementById('qrcode')
          if (qrcodeEl && qrcodeEl.children.length > 0) {
            this.startPolling()
          }
        })
      })
    },

    startPolling () {
      this.timer = setInterval(() => {
        this.getStatus()
      }, 1000)
    },

    getStatus () {
      // 必须等当前订单创建成功后才轮询，且只查询当前订单的支付结果
      if (!this.order_no) return
      var that = this
      axios.get(`/order/pay/getResult?order_no=${this.order_no}`, {noLoading: true}).then(res => {
        console.log('接口返回1111:', res.data)
        if (res.code === 200 && res.data) {
          // 确认返回的是当前订单的结果，避免取到上次购买成功的记录
          const isCurrentOrder = res.data.order_no == null || String(res.data.order_no) === String(that.order_no)
          if (isCurrentOrder && res.data.pay_status !== undefined && res.data.pay_status !== null) {
            if (res.data.pay_status === 'TRADE_SUCCESS') {
              that.ispayed = true
              that.expire_date = res.data.expire_time
              that.stopPolling()
            } else {
              that.stopPolling()
            }
          }
        }
      })
    },
    stopPolling () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      // axios.post('/order/pay/getMember', {}, { noLoading: true }).then(res => {
      //   console.log('接口返回:', res.data)
      //   var patterndate = res.data.expire_time.split('T')[0]
      //   if (res.code === 200) {
      //     this.expire_date = patterndate + ''
      //   }
      // })
    }
  }
}
</script>
<style>
  .pay{
    text-align: center;
  }

  .qrcode-box{
    display: flex;
    justify-content: center;  /* 水平居中 */
    align-items: center;      /* 垂直居中 */
    margin: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Pay.vue